import { createFileRoute } from '@tanstack/react-router';
import { z } from 'zod';

import { QuickBooksOAuth } from '../modules/QuickBooksOAuth';

export const Route = createFileRoute('/quickbooks-oauth')({
  component: RouteComponent,
  head: () => {
    return {
      meta: [{ title: 'QuickBooks OAuth' }],
    };
  },
  validateSearch: z.object({
    code: z.string().optional(),
    realmId: z.coerce.string().optional(),
  }),
});

function RouteComponent() {
  return <QuickBooksOAuth />;
}
